import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { trackByValue } from '@recruitee/common';
import { MessageComponent } from '@recruitee/user-interface';

import { LegalDialogConfig } from '../../types';

@Component({
  selector: 'rt-integration-list-legal-dialog-content',
  standalone: true,
  imports: [MessageComponent, NgTemplateOutlet],
  templateUrl: './integration-list-legal-dialog-content.component.html',
  styleUrls: ['./integration-list-legal-dialog-content.component.less'],
})
export class IntegrationListLegalDialogContentComponent {
  @Input() public claimsHeading: SafeHtml | undefined;
  @Input() public claimsList: SafeHtml[];
  @Input() public textUnderClaims: SafeHtml | undefined;
  @Input() public listType: LegalDialogConfig['listType'] = 'unordered';

  public trackByValue = trackByValue;

  public get orderedClaims(): boolean {
    return this.listType === 'ordered';
  }
}
